<template>
    <div class="rsv_work_state left_panel_item loading_top_wrap" @click="action_Click">
        <div v-if="isLoading" class="loading_bg round_none transparent" style="z-index: 100;">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
                         xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33"
                                r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="left_panel_title relative">
            <span class="title">{{ $t('reservationwindow.leftpannel.label_workrecords') }}</span>
            <button class="btn dgray_txt mgl_5" @click="showFilterOverlay" @click.stop="showFilterOverlay">
                <v-icon small>mdi-tune</v-icon>
            </button>
            <!-- 근무코드 보기 오버레이 -->
            <WorkStateFilterOverlay
                :isShow="isShowFilterOverlay"
                :workCodes="workCodes"
                @hideOverlay="hideFilterOverlay"
                @selectCode="updateWorkCode"
                v-clickoutside:hideFilterOverlay="undefined"/>
            <button class="btn_white btn_round mgl_auto" @click="action_ShowWorkState">{{ $t('reservationwindow.leftpannel.button_manageschedule_title') }}</button>
        </div>
        <div class="work_department_wrap">
            <div class="work_department">
                <div class="empty" v-if="isHoliday">
                    <v-icon>mdi-calendar-alert</v-icon>
                    <span class="txt">{{ $t('reservationwindow.leftpannel.label_noworkingday') }}</span>
                </div>
                <div class="empty" v-if="!isHoliday && parsedOriginalWorkRecord == undefined">
                    <v-icon>mdi-alert-circle</v-icon>
                    <span class="txt">{{ $t('reservationwindow.leftpannel.label_needschedule') }}</span>
                </div>
                <div v-if="!isHoliday && parsedOriginalWorkRecord != undefined">
                    <WorkDepartment
                        v-for="[key, value] of workRecords"
                        :key="key"
                        :departmentID="key"
                        :value="value"
                        :departments="departments"
                        :employees="employees"
                        :workCodes="workCodes"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { sheetState } from '../../../sheet-state'
import { showWorkStatePopup } from '../../../sheet-overlays'
import { exitTimeSelectMode } from '../../../reservation-selection'
import { sheetAxis } from '../../../sheet-axis'
import { sheetRefresh } from '../../../sheet-refresh'
import WorkStateFilterOverlay from './SubViews/WorkStateFilterOverlay.vue'
import WorkDepartment from './SubViews/WorkDepartment.vue'
import moment from '@/util/MPMoment'
import {mapActions} from "vuex";
import store from "@/store";
import { useQueryClient } from '@tanstack/vue-query'
import { v2DepartmentListQueryOptions } from '@/composables/queries/v2department/use-v2-department-find-query'
import { v2EmployeeListQueryOptions } from '@/composables/queries/v2employee/use-v2-employee-find-query'
import { v2WorkCodeListQueryOptions } from '@/composables/queries/v2workcode/use-v2-workcode-find-query'
import { v2WorkRecordFindDateQueryOptions } from '@/composables/queries/v2workrecord/use-v2-workrecord-find-date-query'

export default {
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    components: {WorkStateFilterOverlay, WorkDepartment},
    data() {
        return {
            sheetState,
            sheetAxis,
            sheetRefresh,
            isLoading: false,

            isShowFilterOverlay: false,

            parsedOriginalWorkRecord: undefined,
            workRecords: [],

            departments: [],
            workCodes: [],
            employees: []

        }
    },
    watch: {
        'sheetRefresh.refreshFlagMoment': {
            deep: true,
            handler: function () {
                this.initLoadData()
            }
        },
        parsedOriginalWorkRecord: {
            handler: function (newValue) {
                if (!newValue) return
                let arrayMap = new Map(newValue)
                let ids = [...newValue.keys()]

                let filterData = this.departments.filter(item => !ids.includes(item._id))
                filterData.forEach(department => {
                    arrayMap.set(department._id, [])
                })
                let sortableArray = Array.from(arrayMap).sort((l, r) => {
                    return (this.sortDepartmentMap.get(l[0]) || 0) - (this.sortDepartmentMap.get(r[0]) || 0)
                })
                this.workRecords = new Map(sortableArray)
                this.$forceUpdate()
            }
        }
    },
    computed: {
        selectedDate: function () {
            return this.sheetAxis.selectedDate
        },
        sortDepartmentMap: function () {
            return new Map(this.departments.map(obj => [obj._id, obj.sortNum]))
        },
        isHoliday: function () {
            return this.sheetState.isHoliday
        }
    },
    mounted() {
        this.initLoadData()
    },
    methods: {
        ...mapActions(['AC_V2WorkCodeWithinWorkState_Set', 'AC_V2WorkCodeWithinWorkState_Update']),

        showFilterOverlay() {
            this.isShowFilterOverlay = true
        },
        updateWorkCode(item) {
            let param = {
                hospitalID: this.hospital.selectedHospital._id,
                workCode: item
            }
            this.AC_V2WorkCodeWithinWorkState_Update(param)
        },
        hideFilterOverlay() {
            this.isShowFilterOverlay = false
        },
        action_Click() {
            exitTimeSelectMode()
        },
        action_ShowWorkState() {
            showWorkStatePopup()
        },
        async initLoadData() {
            try {
                this.isLoading = true
                await Promise.all([
                    this.requestFetchDepartments(),
                    this.requestFetchWorkCodes(),
                    this.requestFetchEmployees()
                ])
                await this.requestFetchWorkRecords()
            } catch (err) {
                this.parsedOriginalWorkRecord = undefined
                console.log(err)
            } finally {
                this.isLoading = false
            }
        },
        // MARK :- Network
        async requestFetchDepartments() {

            // 봉투 에러(code != 0)는 ApiError로 throw — 기존의 throw Error(message)와 동일하게 호출자 catch로 전파
            this.departments = await this.queryClient.fetchQuery(v2DepartmentListQueryOptions(this.hospital.selectedHospital._id))
        },
        async requestFetchWorkCodes() {
            let hospitalID = this.hospital.selectedHospital._id

            // 봉투 에러(code != 0)는 ApiError로 throw — 기존의 throw Error(message)와 동일하게 호출자 catch로 전파
            const workCodes = await this.queryClient.fetchQuery(v2WorkCodeListQueryOptions(hospitalID))
            await this.AC_V2WorkCodeWithinWorkState_Set({
                hospitalID: hospitalID,
                workCodes: workCodes
            })
            this.workCodes = store.state.V2WorkCodeWithinWorkState.hospitals[hospitalID] ?? []
        },
        async requestFetchEmployees() {

            // 봉투 에러(code != 0)는 ApiError로 throw — 기존의 throw Error(message)와 동일하게 호출자 catch로 전파
            this.employees = await this.queryClient.fetchQuery(v2EmployeeListQueryOptions(this.hospital.selectedHospital._id))
        },
        async requestFetchWorkRecords() {
            let date = moment(this.selectedDate).format('YYYY-MM-DD')
            let params = {
                hospitalID: this.hospital.selectedHospital._id,
                startDate: date,
                endDate: date,
                isRemoved: false
            }
            // 봉투 에러(code != 0)는 ApiError로 throw — 기존의 throw Error(message)와 동일하게 호출자 catch로 전파
            this.requestFetchWorkRecordsCallback(await this.queryClient.fetchQuery(v2WorkRecordFindDateQueryOptions(params)))
        },
        requestFetchWorkRecordsCallback(data) {
            this.parsedOriginalWorkRecord = data.reduce((acc, record) => {
                record.employees.forEach(e => {
                    if (e.isRemoved) {
                        return
                    }
                    let key = e.departmentID
                    let entry = {
                        employee: e,
                        id: record._id,
                        workCodeID: record.workCodeID,
                        startedAt: record.startedAt,
                        endedAt: record.endedAt,
                        isCustomized: record.isCustomized,
                        isBasic: false
                    }

                    if (!acc.has(key)) {
                        acc.set(key, [])
                    }
                    acc.get(key).push(entry)
                })

                return acc
            }, new Map())
        }
    }
}
</script>